import { useState, useEffect } from "react";

export const photos = [


    { id: "1", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-19.webp' },
    { id: "2", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-20.webp' },
    { id: "3", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-21.webp' },
    { id: "4", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-22.webp' },
    { id: "5", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-23.webp' },
    { id: "6", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-24.webp' },
    { id: "7", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-13.webp' },
    { id: "8", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-14.webp' },
    { id: "9", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-15.webp' },
    { id: "10", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-16.webp' },
    { id: "11", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-17.webp' },
    { id: "12", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-18.webp' },
    { id: "13", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-1.webp' },
    { id: "14", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-2.webp' },
    { id: "15", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-4.webp' },
    { id: "16", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-5.webp' },
    { id: "17", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-6.webp' },
    { id: "18", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-7.webp' },
    { id: "19", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-8.webp' },
    { id: "20", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-9.webp' },
    { id: "21", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-10.webp' },
    { id: "22", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-11.webp' },
    { id: "23", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-12.webp' },
    { id: "24", src: 'https://d2lyw5vkb9es5b.cloudfront.net/Collage-Col-3.webp' },
]

const rows = [
    photos.slice(0, 6),
    photos.slice(6, 12),
    photos.slice(12, 18),
    photos.slice(18, 24)
];

const css = `
.pg-wrap{
padding-bottom:8rem;
 display:flex;
 flex-direction:column;
 gap:5px;
 overflow:hidden;
}

.pg-row{
 overflow:hidden;
 width:100%;
}

.pg-track{
 display:flex;
 gap:5px;
 width:max-content;
}

/* images */
.pg-track img{
 width:calc((100vw - 0px)/6);
//  height:180px;
//  object-fit:cover;
 border-radius:25px;
//  flex-shrink:0;
 transition:.35s;
}



/* LEFT → RIGHT animation */
@keyframes scroll{
 from{ transform:translate3d(-50%,0,0); }
 to{ transform:translate3d(0,0,0); }
}

.pg-row:hover .pg-track{
 animation-play-state:paused;
}

/* tablet */
@media(max-width:1000px){
 .pg-track img{
  width:calc((100vw - 50px)/3);

 }
}

/* mobile */
@media(max-width:600px){
 .pg-track img{
  width:calc((100vw - 40px)/2);
 }
}
`;

export default function SmoothRows() {

    const [selected, setSelected] = useState(null);

    useEffect(() => {
        document.body.style.overflow = selected ? "hidden" : "auto";
    }, [selected]);

    return (
        <>
            <style>{css}</style>

            <div className="pg-wrap">

                {rows.map((row, rowIndex) => {

                    const duration = 30 + rowIndex * 8;

                    return (
                        <div className="pg-row" key={rowIndex}>
                            <div
                                className="pg-track"
                                style={{
                                    animation: `scroll 54s linear infinite`
                                }}
                            >
                                {[...row, ...row].map((p, i) => (
                                    <img
                                        key={i}
                                        src={p.src}
                                        alt={p.id}
                                        onClick={() => setSelected(p.src)}
                                    />
                                ))}
                            </div>
                        </div>
                    )
                })}

            </div>
        </>
    );
}
